import {PipeTransform, Pipe} from '@angular/core';
import {Utilities} from '../utilities/utilities.model';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {isNumeric} from 'rxjs/util/isNumeric';

@Pipe({
	name: 'highlight'
})
export class HighLightPipe implements PipeTransform {
	constructor(private sanitized: DomSanitizer) {}
	transform(text: string, search: string): SafeHtml {
		let start = -1;
		if (!Utilities.isVoid(search) && !Utilities.isVoid(text)) {
			if (isNumeric(text)) {
				text = text.toString();
			}
			if (isNumeric(search)) {
				search = search.toString();
			}
			start = text.toUpperCase().search(new RegExp(search.toUpperCase(), 'i'));
		}
		const value = start > -1 ? text.replace(new RegExp(search, 'i'),
			'<span class="u-search-highlight">' + text.substring(start, start + search.length) + '</span>') :
			(!Utilities.isVoid(text) ? text : null);
		return this.sanitized.bypassSecurityTrustHtml(value);
	}
}

/** Usage:
 * <input type="text" [(ngModel)]="filter">
 * <div [innerHTML]="myAwesomeText  | highlight : filter"></div>
 *
 */
